// removed by extract-text-webpack-plugin
module.exports = {"Score":"Qe_FtbGO35oWy_pIj4qk_","title":"VURh4_WpaEm0xn8DVHUc-","value":"_1UcmNV5rdd87CX_KRDcwCN"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Score/Score.scss
 ** module id = 397
 ** module chunks = 1
 **/